import type { Brand } from "@syllarys/contracts";

export function resolveBrandForRoute(
  hostBrand: Brand,
  sessionBrand: Brand | undefined,
  pathname: string,
): Brand {
  const isAuthenticatedAppRoute =
    pathname === "/app" || pathname.startsWith("/app/");

  return isAuthenticatedAppRoute && sessionBrand?.status === "active"
    ? sessionBrand
    : hostBrand;
}

export function resolveBrandForHost(
  brands: Brand[],
  hostname: string,
  previewSlug = "",
): Brand {
  const activeBrands = brands.filter((brand) => brand.status === "active");
  const previewBrand = activeBrands.find((brand) => brand.slug === previewSlug);
  if (previewBrand) return previewBrand;

  const normalizedHostname = hostname.toLowerCase();
  const domainBrand = activeBrands.find((brand) =>
    brand.domains.some(
      (domain) =>
        domain.verified && domain.hostname.toLowerCase() === normalizedHostname,
    ),
  );
  const resolved =
    domainBrand ??
    activeBrands.find((brand) => brand.isDefault) ??
    activeBrands[0] ??
    brands[0];

  if (!resolved) throw new Error("Aucune marque EMS active n'est configuree.");
  return resolved;
}
